import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import StatsAPI from "../../../api/StatsAPI";
import Timeline from "../../timeline/Timeline";
import { CONTENTS_ROUTE } from "../../routes/routes";
import { TIME_FORMAT_SHORT } from "../../../constants/dateFormat";

function UserLastWatched({ userId }) {
  const history = useHistory();
  const { t } = useTranslation("editor-analytics");
  const { projectSlug } = useParams();

  const getUserLastWatchedQuery = StatsAPI.generateQuery({
    fn: StatsAPI.getUserLastWatched,
    params: [
      {
        userId,
        projectSlug,
      },
    ],
  });

  const { data: userLastWatched, isLoading } = useQuery({
    ...getUserLastWatchedQuery,
    enabled: !!userId,
  });

  const itemList = userLastWatched?.data.slice(0, 20).map((item) => {
    const cardPicture = item?.media_picture;
    const cardTitle = item?.label;
    const durationString = moment
      .duration(item?.duration, "seconds")
      .format("*HH:*mm:ss");
    const dateString = moment(item?.datetime).format("DD/MM/YYYY");
    const timeString = moment(item?.datetime).format(TIME_FORMAT_SHORT);
    const label = item?.label;

    const onClick = () => {
      history.push(`${CONTENTS_ROUTE}/${item.media_type}/${item.media_uuid}`);
    };

    return {
      item,
      cardPicture,
      cardTitle,
      durationString,
      dateString,
      timeString,
      label,
      onClick,
    };
  });

  return (
    <Timeline
      isLoading={isLoading}
      itemList={itemList}
      emptyMessage={t("noLastWatchedContent")}
      title={t("lastWatchedContent")}
    />
  );
}

UserLastWatched.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default UserLastWatched;
